export const GET_CONTACTS = "GET_CONTACTS";
export const NEW_REQUEST = "NEW_REQUEST";
export const ADD_REQUEST = "ADD_REQUEST";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const FETCH_CONTACTS_REQUEST = "FETCH_CONTACTS_REQUEST";
export const FETCH_CONTACTS_SUCCESS = "FETCH_CONTACTS_SUCCESS";
export const FETCH_CONTACTS_FAILURE = "FETCH_CONTACTS_FAILURE";
export const UPDATE_CONTACTS = "UPDATE_CONTACTS";
// SOCKET ACTIONS
export const SOCKET_CONNECT = "SOCKET_CONNECT";
export const SOCKET_DISCONNECT = "SOCKET_DISCONNECT";
export const ONLINE_USERS = "ONLINE_USERS";

// CHAT ACTION TYPES
export const IOS_PRV_MESSAGES = "IOS_PRV_MESSAGES";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const IOS_PRV_TYPING = "IOS_PRV_TYPING";
export const SELECTED_CONTACT = "SELECTED_CONTACT";
export const CONTACT_REFRESH = "CONTACT_REFRESH";
export const SELECTED_CHAT = "SELECTED_CHAT";
export const SEND_ATTACHMENT = "SEND_ATTACHMENT";
export const START_RECORDING = "START_RECORDING";
export const STOP_RECORDING = "STOP_RECORDING";
export const TYPING = "TYPING";
export const STOP_TYPING = "STOP_TYPING";
export const FETCH_MESSAGE = "FETCH_MESSAGE";
export const FETCH_MESSAGE_SUCCESS = "FETCH_MESSAGE_SUCCESS";
export const FETCH_MESSAGE_FAILURE = "FETCH_MESSAGE_FAILURE";
export const EDIT_MESSAGE = "EDIT_MESSAGE";
export const EDIT_MESSAGE_TEXT_SUCCESS = "EDIT_MESSAGE_TEXT_SUCCESS";
export const CHAT_CLICKED_IN_CALL = "CHAT_CLICKED_IN_CALL";
export const SELECT_SENDER = "SELECT_SENDER";
export const SELECT_RECEIVER = "SELECT_RECEIVER";
export const CHAT_OPEN = "CHAT_OPEN";

// CALL ACTION TYPES
export const SET_VIDEO_SWITCH = "SET_VIDEO_SWITCH";
export const SET_CALL_USER = "SET_CALL_USER";
export const SET_BLOCK = "SET_BLOCK";
export const SET_REPORT = "SET_REPORT";
export const HANDLE_CALL = "HANDLE_CALL";
export const IN_CALL = "IN_CALL";

// MENU ACTION TYPES
export const SET_MENU_CLICK = "SET_MENU_CLICK";
// SNACKBAR
export const SET_SNACKBAR = "SET_SNACKBAR";
// USER DETAIL
export const USER_DETAIL = "USER_DETAIL";
export const PRESENT_SCREEN = "PRESENT_SCREEN";

// NOTIFICATION
export const PENDING_CHATS = "PENDING_CHATS";
